export const selectElementModel = {
  name: "",
  value: "",
  onChange: () => {},
  options: [], // Options should be an array of objects with `label` and `value` properties
  label: "",
  error: null,
  required: false,
  disabled: false,
  className: "",
  style: {},
  removeDefaultStyle: false,
};
